import React from 'react';
import { Slider } from '../../../ui/slider';
import { Button } from '../../../ui/button';
import { Trash2, Music, Mic, Volume2 } from 'lucide-react';

export const AudioEditor = ({ segment, totalDuration, onUpdate, onRemove }) => (
  <div className="px-3 py-2 border-t border-border/30" data-testid="audio-detail-editor">
    <div className="flex items-center gap-3 flex-wrap">
      <div className="flex items-center gap-1">
        {segment.type === 'music' ? <Music className="h-3 w-3 text-emerald-400" /> : <Mic className="h-3 w-3 text-amber-400" />}
        <span className="text-[10px] font-medium truncate max-w-[120px]">{segment.name}</span>
      </div>
      <div className="flex items-center gap-1.5" data-testid="audio-start-control">
        <label className="text-[10px] text-muted-foreground">Start</label>
        <Slider
          value={[segment.start_time || 0]}
          onValueChange={([v]) => onUpdate({ start_time: parseFloat(v.toFixed(1)) })}
          min={0} max={Math.max(totalDuration, 60)} step={0.1} className="w-20"
        />
        <span className="text-[10px] font-mono w-8">{(segment.start_time || 0).toFixed(1)}s</span>
      </div>
      <div className="flex items-center gap-1.5" data-testid="audio-volume-control">
        <Volume2 className="h-3 w-3 text-muted-foreground" />
        <Slider
          value={[segment.volume || 100]}
          onValueChange={([v]) => onUpdate({ volume: v })}
          min={0} max={100} step={5} className="w-20"
        />
        <span className="text-[10px] font-mono w-8">{segment.volume || 100}%</span>
      </div>
      <Button variant="ghost" size="icon" className="h-6 w-6 text-destructive ml-auto" onClick={onRemove} data-testid="remove-audio-seg">
        <Trash2 className="h-3 w-3" />
      </Button>
    </div>
  </div>
);
